import aesReduxConstants from '../../../constants';

const sopListReducer = function() {
  const constants = aesReduxConstants;

  const defaultState = [
  ];

  const reducer = function(state, action) {
    if (state === undefined) {
      return defaultState;
    }

    let sops = [];
    switch (action.type) {
      case constants.GET_CLIENT_SOP_LIST_SUCCESS:
        if (action.pages == null) {
          return [];
        }
        sops = action.pages;

        break;
      default:
        return state;
    }
    return sops;
  };

  return reducer;
};

export default sopListReducer();
